import { GridColumnSettings } from '@/shared/types/grid';

export const notesIconColumn = <T>(options: { uid?: string; field: keyof T & string }): GridColumnSettings<T> => {
  const { uid, field } = options;

  return {
    uid: uid ?? field,
    field,
    type: 'boolean',
    headerText: '',
    headerTemplate: `<i class="grid-tooltip fa-regular fa-note-sticky text-more-muted" title="Notes (First Line)" data-bs-placement="top"></i>`,
    template: `\${if(${options.field})}<i class="grid-tooltip fa-regular fa-note-sticky text-primary" title="\${notesExcerpt}" data-bs-placement="right"></i>\${/if}`,
    clipMode: 'Clip',
    headerTextAlign: 'Center',
    textAlign: 'Center',
    allowReordering: false,
    allowFiltering: false,
    showInColumnChooser: false,
    width: 30,
  };
};
